import { ISelectOption } from 'libs/common-ui/dist'

export const contactTypeOptions: ISelectOption[] = [
  { title: 'Plumber', value: 'Plumber' },
  { title: 'Electrician', value: 'Electrician' },
  { title: 'Other', value: 'Other' },
]
